import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Route as PortfolioBorrowingBaseView } from '~/core/routes/credit-facilities/[creditFacilityId]/borrowing-base/_index';
import { Route as PortfolioCovenantsView } from '~/core/routes/credit-facilities/[creditFacilityId]/covenants/_index';
import { Route as PortfolioCreditAgreementView } from '~/core/routes/credit-facilities/[creditFacilityId]/credit-agreement/_index';
import { Route as PortfolioFinancialsView } from '~/core/routes/credit-facilities/[creditFacilityId]/financials/_index';
import { Route as PortfolioSummaryView } from '~/core/routes/credit-facilities/[creditFacilityId]/funding-overview/_index';
import { Route as PortfolioProfitLossView } from '~/core/routes/credit-facilities/[creditFacilityId]/performance/_index';
import { Route as PortfolioReceivableDetailsView } from '~/core/routes/credit-facilities/[creditFacilityId]/receivables/[receivableId]/_index';
import { Route as PortfolioReceivablesView } from '~/core/routes/credit-facilities/[creditFacilityId]/receivables/_index';
import { Route as PortfolioReportBuilderView } from '~/core/routes/credit-facilities/[creditFacilityId]/report-builder/_index';
import { Route as PortfolioStratsView } from '~/core/routes/credit-facilities/[creditFacilityId]/strats/_index';
import { Route as PortfolioOverviewFacilitiesRoute } from '~/core/routes/credit-facilities/_index';
import { AthenaSchemaProvider } from '~/packages/organization/hooks/AthenaSchemaContext';

export const PortfolioRouter = () => {
  return (
    <AthenaSchemaProvider>
      {/* Paths relative to "/portfolio/*" */}
      <Routes>
        <Route
          path="/overview/facilities"
          element={
            <Flex
              direction="column"
              padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
            >
              <PortfolioOverviewFacilitiesRoute />
            </Flex>
          }
        />

        {/* !TODO @eldarshamukhamedov Many of these routes use query params to store facilityID, should use route params instead */}
        <Route path="/summary" element={<PortfolioSummaryView />} />
        <Route
          path="/portfolio-covenants"
          element={<PortfolioCovenantsView />}
        />
        <Route path="/financials" element={<PortfolioFinancialsView />} />
        <Route
          path="/borrowing-base"
          element={<PortfolioBorrowingBaseView />}
        />
        <Route path="/profit-loss" element={<PortfolioProfitLossView />} />
        <Route path="/receivables" element={<PortfolioReceivablesView />} />
        <Route
          path="/receivables/:finleyReceivableId"
          element={<PortfolioReceivableDetailsView />}
        />
        <Route
          path="/credit-agreement"
          element={<PortfolioCreditAgreementView />}
        />
        <Route path="/strats" element={<PortfolioStratsView />} />
        <Route
          path="/report-builder"
          element={<PortfolioReportBuilderView />}
        />
        <Route
          path="/*"
          element={<Navigate to="/portfolio/overview/facilities" replace />}
        />
      </Routes>
    </AthenaSchemaProvider>
  );
};
